let token: string | null = null;

const setToken = (t: string) => {
  token = t;
};

type Payload = {
  [key: string]: string | number | undefined | null | Record<string, any>;
};

const serialize = (params: Payload) => {
  const components: string[] = [];

  for (const key in params) {
    // eslint-disable-next-line
    if (!params.hasOwnProperty(key) || params[key] == null) {
      continue;
    }

    components.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(params[key]))}`);
  }

  return components.join('&');
};

type HttpType = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

const defaultResponse = { activities: [], hidden_activities: [] };

const send = async (uri: string, method: HttpType = 'GET', body?: Payload) => {
  try {
    const response = await fetch(uri, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: body ? JSON.stringify(body) : null,
    });

    if (!response.ok) {
      return new Promise((resolve) => resolve(defaultResponse));
    }

    return response.json();
  } catch (error) {
    return new Promise((resolve) => resolve(defaultResponse));
  }
};

const getActivitySummary = (count: number, before?: string, after?: string) =>
  send(`/activity/json?${serialize({ count, before, after })}`);

const postActivityAcknowledged = (activityId: string) =>
  send(`/activity/json/mark_seen/${activityId}`, 'POST', { token });

const postToggleFollow = (userId: number) =>
  send(`/user${userId}/toggle_follow`, 'POST', {
    token,
    body: { subject_id: userId },
  });

const postPriorActivitiesDisplayed = (activityId: string) =>
  send(`/activity/json/mark_old/${activityId}`, 'POST', { token });

export {
  getActivitySummary,
  postActivityAcknowledged,
  postToggleFollow,
  postPriorActivitiesDisplayed,
  setToken,
};
